<template>
  <div>
    <component
      :is="getViewerComponent"
      :file="file"
      :attributes="attributes"
      :getMediaUrl="getMediaUrlById"
      :getMedia="getMedia"
    >
    </component>
  </div>
</template>

<script>
import { getViewer } from './';
import localApi from '../../../common/api/local';
import { getDamService } from '../../services';

export default {
  name: 'pui-dam-viewer-container',
  props: {
    file: {
      type: Object,
      required: true,
    },
    attributes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    getViewerComponent() {
      // TODO a modifier quand on pourra brancher le type MIME
      // Actuellement la valeur n'est pas renseignée dans la propriété
      if (this.file && this.file.description && this.file.description.extension) {
        return getViewer(this.file.description.extension);
      } else {
        return getViewer();
      }
    },
  },
  methods: {
    /**
     * Calls the media api to retrieve the url to the ressource
     *
     * @returns {Promise<string>}
     */
    async getMediaUrlById() {
      try {
        const response = await getDamService('filesService').getMediaUrlById(
          'viewerContainer',
          this.file.itemId
        );
        return response.body;
      } catch (error) {
        throw new Error(error);
      }
    },
    /**
     * @param {string} [expectedContentType=null] - the expected Content-Type of the media.
     * If it is not the same, the request will be canceled and the promise will reject
     * @returns {Promise<string>} an objectUrl to the ressource
     */
    async getMedia(expectedContentType = null) {
      const url = await this.getMediaUrlById();
      return localApi.createObjectUrlFromRemote(url, expectedContentType);
    },
  },
};
</script>
